import React, { useState } from 'react';
import s from './Auth.module.css';
import { Btn } from './Btn';
import { Field, Inp } from './Inp';
import { store } from '../../utils/store';
import { supabase } from '../../utils/supabase';
import { fmtPhone } from '../../utils/helpers';

// Input de senha com botão olho
function SenhaInp({ value, onChange, placeholder = '••••••', ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <Inp
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ paddingRight: 40 }}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow(v => !v)}
        style={{
          position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer',
          color: 'var(--g400)', display: 'flex', alignItems: 'center', padding: 4,
          transition: 'color .15s',
        }}
        tabIndex={-1}
        title={show ? 'Ocultar senha' : 'Mostrar senha'}
      >
        {show
          ? <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          : <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        }
      </button>
    </div>
  );
}

function Logo() {
  return (
    <div className={s.logo}>
      <div className={s.lb}>A</div>
      <h1 className={s.lt}>AgendaPro</h1>
      <p className={s.ls}>Gestão de Agendamentos</p>
    </div>
  );
}

export function ResetSenha({ onDone }) {
  const [pass, setPass] = useState('');
  const [conf, setConf] = useState('');
  const [err,  setErr]  = useState('');
  const [ok,   setOk]   = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (pass.length < 6) { setErr('Senha mínima 6 caracteres.'); return; }
    if (pass !== conf)   { setErr('Senhas não conferem.'); return; }
    setLoading(true);
    try {
      await store.atualizarSenhaAdmin(pass);
      setOk(true);
      setTimeout(() => onDone(), 2000);
    } catch (error) { setErr(error.message); }
    finally { setLoading(false); }
  };

  return (
    <div className={s.page}><div className={s.card}>
      <Logo />
      <h2 className={s.ft}>Nova Senha</h2>
      <p className={s.fs}>Digite sua nova senha de acesso</p>
      {ok && <div className={s.succ}>✅ Senha atualizada! Redirecionando...</div>}
      {!ok && <>
        {err && <div className={s.err}>⚠️ {err}</div>}
        <form onSubmit={submit}>
          <Field label="Nova Senha" required hint="mín. 6 caracteres">
            <SenhaInp value={pass} onChange={e => setPass(e.target.value)} required />
          </Field>
          <Field label="Confirmar Nova Senha" required>
            <SenhaInp value={conf} onChange={e => setConf(e.target.value)} required />
          </Field>
          <Btn type="submit" style={{ width: '100%', justifyContent: 'center', padding: '11px' }} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar Nova Senha'}
          </Btn>
        </form>
      </>}
    </div></div>
  );
}

export function Login({ onLogin, onRegister }) {
  const [email,  setEmail]  = useState('');
  const [pass,   setPass]   = useState('');
  const [err,    setErr]    = useState('');
  const [loading, setLoading] = useState(false);
  const [modo,   setModo]   = useState('login'); // login | esqueci
  const [emailEnviado, setEmailEnviado] = useState(false);

  const submitLogin = async (e) => {
    e.preventDefault(); setErr(''); setLoading(true);
    try {
      await store.login(email, pass);
      onLogin();
    } catch (error) {
      setErr(error.message === 'Invalid login credentials' ? 'E-mail ou senha inválidos.' : error.message);
    } finally { setLoading(false); }
  };

  const submitEsqueci = async (e) => {
    e.preventDefault(); setErr('');
    if (!email.trim()) { setErr('Informe seu e-mail.'); return; }
    setLoading(true);
    try {
      await store.resetSenhaAdmin(email.trim());
      setEmailEnviado(true);
    } catch (error) { setErr(error.message); }
    finally { setLoading(false); }
  };

  if (modo === 'esqueci') return (
    <div className={s.page}><div className={s.card}>
      <Logo />
      <h2 className={s.ft}>Esqueci minha senha</h2>
      <p className={s.fs}>Enviaremos um link para redefinir sua senha</p>
      {emailEnviado
        ? <div className={s.succ}>✅ E-mail enviado! Verifique sua caixa de entrada e clique no link para redefinir.</div>
        : <>
          {err && <div className={s.err}>⚠️ {err}</div>}
          <form onSubmit={submitEsqueci}>
            <Field label="E-mail" required>
              <Inp type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required autoComplete="email" />
            </Field>
            <Btn type="submit" style={{ width: '100%', justifyContent: 'center', padding: '11px' }} disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar link de redefinição'}
            </Btn>
          </form>
        </>
      }
      <p className={s.sw}><span className={s.lk} onClick={() => { setModo('login'); setErr(''); setEmailEnviado(false); }}>← Voltar ao login</span></p>
    </div></div>
  );

  return (
    <div className={s.page}><div className={s.card}>
      <Logo />
      <h2 className={s.ft}>Entrar</h2>
      <p className={s.fs}>Acesse sua conta para continuar</p>
      {err && <div className={s.err}>⚠️ {err}</div>}
      <form onSubmit={submitLogin}>
        <Field label="E-mail" required>
          <Inp type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required autoComplete="email" />
        </Field>
        <Field label="Senha" required>
          <SenhaInp value={pass} onChange={e => setPass(e.target.value)} required />
        </Field>
        <div style={{ textAlign: 'right', marginTop: -8, marginBottom: 16 }}>
          <span className={s.lk} style={{ fontSize: 12 }} onClick={() => { setModo('esqueci'); setErr(''); }}>
            Esqueci minha senha
          </span>
        </div>
        <Btn type="submit" style={{ width: '100%', justifyContent: 'center', padding: '11px' }} disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </Btn>
      </form>
      <p className={s.sw}>Não tem conta? <span className={s.lk} onClick={onRegister}>Criar conta gratuita</span></p>
    </div></div>
  );
}

export function Register({ onLogin, onBack }) {
  const [f, setF] = useState({ empresa: '', nome: '', email: '', wa: '', pass: '', conf: '' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const u = (k, v) => setF(x => ({ ...x, [k]: v }));

  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (!f.empresa.trim() || !f.nome.trim() || !f.email.trim()) { setErr('Preencha todos os campos.'); return; }
    if (f.pass.length < 6) { setErr('Senha mínima 6 caracteres.'); return; }
    if (f.pass !== f.conf) { setErr('Senhas não conferem.'); return; }
    setLoading(true);
    try {
      await store.register({ empresa: f.empresa.trim(), nome: f.nome.trim(), email: f.email.trim(), wa: f.wa, password: f.pass });
      onLogin();
    } catch (error) { setErr(error.message); }
    finally { setLoading(false); }
  };

  return (
    <div className={s.page}><div className={s.card} style={{ maxWidth: 460 }}>
      <Logo />
      <h2 className={s.ft}>Criar Conta</h2>
      <p className={s.fs}>Comece grátis, sem cartão de crédito</p>
      {err && <div className={s.err}>⚠️ {err}</div>}
      <form onSubmit={submit}>
        <Field label="Nome da Empresa" required><Inp value={f.empresa} onChange={e => u('empresa', e.target.value)} placeholder="Salão Beleza Total" required /></Field>
        <Field label="Seu Nome" required><Inp value={f.nome} onChange={e => u('nome', e.target.value)} placeholder="Maria Silva" required /></Field>
        <Field label="E-mail" required><Inp type="email" value={f.email} onChange={e => u('email', e.target.value)} placeholder="maria@email.com" required /></Field>
        <Field label="WhatsApp"><Inp value={f.wa} onChange={e => u('wa', fmtPhone(e.target.value))} placeholder="(11) 99999-9999" /></Field>
        <Field label="Senha" required hint="mín. 6 caracteres">
          <SenhaInp value={f.pass} onChange={e => u('pass', e.target.value)} required />
        </Field>
        <Field label="Confirmar Senha" required>
          <SenhaInp value={f.conf} onChange={e => u('conf', e.target.value)} required />
        </Field>
        <Btn type="submit" style={{ width: '100%', justifyContent: 'center', padding: '11px' }} disabled={loading}>
          {loading ? 'Criando conta...' : 'Criar Conta'}
        </Btn>
      </form>
      <p className={s.sw}>Já tem conta? <span className={s.lk} onClick={onBack}>Fazer login</span></p>
    </div></div>
  );
}
